const hash = {
  left: 'top',
  right: 'bottom',
  bottom: 'right',
  top: 'left',
} as const;

type Placements = keyof typeof hash;

export default function getAlteredPosition(placement: string) {
  return placement.replace(/left|right|bottom|top/g, (matched: string) => hash[matched as Placements]);
}
